import React from 'react'
import { FormControlLabel, FormControlLabelProps } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  root: {
    padding: '0px !important',
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
      fontWeight: 400,
      fontFamily: 'Montserrat',
    },
  },
})

export const CustomFormControlLabel: React.FC<FormControlLabelProps> = props => {
  const classes = useStyles()

  return <FormControlLabel {...props} className={classes.root} />
}
